import { Cake, ArrowRight } from "lucide-react";
import { useCopy } from "@/contexts/CopyContext";

export default function AddBirthdayCard({ onOpen }) {
  const { t } = useCopy();
  return (
    <div className="bd-card flex flex-col sm:flex-row gap-4 sm:items-center" data-testid="add-birthday-card">
      <span
        className="w-12 h-12 grid place-items-center shrink-0"
        style={{
          background: "var(--primary)",
          color: "var(--primary-fg)",
          borderRadius: "var(--radius-btn)",
        }}
      >
        <Cake size={20} />
      </span>
      <div className="flex-1">
        <h3 className="font-bold text-lg" style={{ letterSpacing: "-0.02em" }}>
          {t("dashboard.add_birthday_card_title", "Add your birthday")}
        </h3>
        <p style={{ color: "var(--text-dim)" }}>
          {t("dashboard.add_birthday_card_body",
            "Share your birthday once so the people in your groups never miss it.")}
        </p>
      </div>
      <button
        className="bd-btn"
        onClick={onOpen}
        data-testid="add-birthday-card-cta"
      >
        Share my birthday <ArrowRight size={14} />
      </button>
    </div>
  );
}
